import axiosInstance from "../axiosInstance";

export const GETListarDisponibles = async () => {
  try {
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_WMS_BASE_URL}/auditoria-sma/listar-disponibles`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    // Errores de red u otros
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default GETListarDisponibles;
